module.exports = __webpack_public_path__ + "static/media/pawel-nolbert.b317bb17.jpg";